import { render, staticRenderFns } from "./RFQs.vue?vue&type=template&id=1b0340ac&scoped=true"
import script from "./RFQs.vue?vue&type=script&lang=js"
export * from "./RFQs.vue?vue&type=script&lang=js"
import style0 from "./RFQs.vue?vue&type=style&index=0&id=1b0340ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0340ac",
  null
  
)

export default component.exports